import { render, staticRenderFns } from "./customerServiceCenter.vue?vue&type=template&id=4b1c9421&scoped=true&"
import script from "./customerServiceCenter.vue?vue&type=script&lang=js&"
export * from "./customerServiceCenter.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceCenter.vue?vue&type=style&index=0&id=4b1c9421&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c9421",
  null
  
)

export default component.exports